/** Most page numbers to render before falling back to a windowed range. */
export const MAX_PAGE_NUMBERS = 5

/**
 * The page numbers a pager should show: all of them when they fit,
 * otherwise a window of `MAX_PAGE_NUMBERS` centred on the current page and
 * clamped to the ends so the window never runs off either edge.
 */
export function pageWindow(page: number, totalPages: number): number[] {
  if (totalPages <= MAX_PAGE_NUMBERS) {
    return Array.from({ length: totalPages }, (_, i) => i + 1)
  }
  const half = Math.floor(MAX_PAGE_NUMBERS / 2)
  const first = Math.min(Math.max(1, page - half), totalPages - MAX_PAGE_NUMBERS + 1)
  return Array.from({ length: MAX_PAGE_NUMBERS }, (_, i) => first + i)
}
